// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.accountview.properties.RentalManagerAccountViewZramMultifamilyWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_list,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_options,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_sources,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Path,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_status,
  RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Path,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  AccountViewListingAdvertisingDto,
  AccountViewListingOptionsDto,
  AccountViewListingProspectsDto,
  AccountViewListingQualityScoreDto,
  AccountViewListingsDto,
  AccountViewListingSourcesDto,
  AccountViewListingStatusOverviewDto,
  ListingAlias,
  RentalManagerListingFieldSortType,
} from '@zg-rentals/ts-rental-manager-api-client';

interface AdvertisingParams {
  listingAlias: ListingAlias;
}
interface ListParams {
  ascending?: boolean;
  includeActive?: boolean;
  includeArchived?: boolean;
  includeAtRiskOnly?: boolean;
  includeFreeBonusListingsOnly?: boolean;
  includeFreeClaimedListingsOnly?: boolean;
  includeInactive?: boolean;
  includeListingCounts?: boolean;
  includeUnarchived?: boolean;
  limit?: number;
  offset?: number;
  searchText?: string;
  sort?: RentalManagerListingFieldSortType;
  startKeyExclusive?: string;
}
interface ListingQualityScoreParams {
  listingAlias: ListingAlias;
}
interface OptionsParams {
  listingAlias: ListingAlias;
}
interface ProspectsParams {
  listingAlias: ListingAlias;
}
interface SourcesParams {
  listingAlias: ListingAlias;
}
interface StatusParams {
  listingAlias: ListingAlias;
}

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Options = UseQueryOptions<
  AccountViewListingAdvertisingDto,
  unknown,
  AccountViewListingAdvertisingDto,
  readonly [string, AdvertisingParams]
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_GetKey = (getParams: AdvertisingParams) =>
  [RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Path, getParams] as const;

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_queryOptions = (
  getParams: AdvertisingParams,
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get multifamily customer account view property listing advertising
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_advertising = (
  getParams: AdvertisingParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_advertising.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_advertising_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Options = UseQueryOptions<
  AccountViewListingsDto,
  unknown,
  AccountViewListingsDto,
  readonly [string, ListParams]
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_list_GetKey = (getParams: ListParams) =>
  [RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Path, getParams] as const;

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_list_queryOptions = (getParams: ListParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_list_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_list(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get multifamily customer account view property list
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_list = (
  getParams: ListParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_list_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramMultifamilyWebApiHandler_list_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_list.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_list_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Options = UseQueryOptions<
  AccountViewListingQualityScoreDto,
  unknown,
  AccountViewListingQualityScoreDto,
  readonly [string, ListingQualityScoreParams]
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_GetKey = (
  getParams: ListingQualityScoreParams,
) => [RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Path, getParams] as const;

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_queryOptions = (
  getParams: ListingQualityScoreParams,
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get multifamily customer account view property listing quality score
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore = (
  getParams: ListingQualityScoreParams,
  options: Omit<
    RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_Options,
    'queryFn' | 'queryKey'
  > = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_listingQualityScore_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Options = UseQueryOptions<
  AccountViewListingOptionsDto,
  unknown,
  AccountViewListingOptionsDto,
  readonly [string, OptionsParams]
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_options_GetKey = (getParams: OptionsParams) =>
  [RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Path, getParams] as const;

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_options_queryOptions = (getParams: OptionsParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_options_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_options(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get multifamily customer account view property listing options
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_options = (
  getParams: OptionsParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_options_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramMultifamilyWebApiHandler_options_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_options.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_options_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Options = UseQueryOptions<
  AccountViewListingProspectsDto,
  unknown,
  AccountViewListingProspectsDto,
  readonly [string, ProspectsParams]
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_GetKey = (getParams: ProspectsParams) =>
  [RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Path, getParams] as const;

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_queryOptions = (
  getParams: ProspectsParams,
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get multifamily customer account view property prospects
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_prospects = (
  getParams: ProspectsParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_prospects.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_prospects_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Options = UseQueryOptions<
  AccountViewListingSourcesDto,
  unknown,
  AccountViewListingSourcesDto,
  readonly [string, SourcesParams]
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_GetKey = (getParams: SourcesParams) =>
  [RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Path, getParams] as const;

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_queryOptions = (getParams: SourcesParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_sources(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get multifamily customer account view property listing sources
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_sources = (
  getParams: SourcesParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_sources.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_sources_GetKey;

export type RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Options = UseQueryOptions<
  AccountViewListingStatusOverviewDto,
  unknown,
  AccountViewListingStatusOverviewDto,
  readonly [string, StatusParams]
>;

const RentalManagerAccountViewZramMultifamilyWebApiHandler_status_GetKey = (getParams: StatusParams) =>
  [RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Path, getParams] as const;

export const RentalManagerAccountViewZramMultifamilyWebApiHandler_status_queryOptions = (getParams: StatusParams) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerAccountViewZramMultifamilyWebApiHandler_status_GetKey(getParams),
    queryFn: () => RentalManagerAccountViewZramMultifamilyWebApiHandler_status(getParams),
  }) as const satisfies QueryOptions;

/**
 * Get multifamily customer account view property listing status
 */
export const useRentalManagerAccountViewZramMultifamilyWebApiHandler_status = (
  getParams: StatusParams,
  options: Omit<RentalManagerAccountViewZramMultifamilyWebApiHandler_status_Options, 'queryFn' | 'queryKey'> = {},
) => {
  return useQuery({
    ...RentalManagerAccountViewZramMultifamilyWebApiHandler_status_queryOptions(getParams),
    ...options,
  });
};
useRentalManagerAccountViewZramMultifamilyWebApiHandler_status.getKey =
  RentalManagerAccountViewZramMultifamilyWebApiHandler_status_GetKey;
